<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-12">
          <h5>Student Photos</h5>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="row">
          <!-- Session Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedSession"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleSessionChange"
              :filterOption="false"
              :defaultValue="currentSession ? currentSession.id : ''"
            >
            <template v-for="schoolSession in schoolSessions">
              <a-select-option :value="schoolSession.id" :key="schoolSession.id">
                  {{schoolSession.name}}
                  <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
              </a-select-option>
            </template>
            </a-select>
          </div>
          <!-- Class Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="classSpinning">
              <a-select
                size="large"
                v-model="selectedClass"
                placeholder="All Classes"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleClassSelect"
                :filterOption="false"
                :defaultValue="undefined"
              >
                <a-select-option :value="undefined">All Classes</a-select-option>
                <template v-for="schoolClass in schoolClasses">
                  <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                  {{schoolClass.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Section Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="sectionSpinning">
              <a-select
              size="large"
                v-model="selectedSection"
                placeholder="All Sections"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleSectionChange"
                :filterOption="false"
                :defaultValue="undefined"
                :disabled="!selectedClass"
              >
                <a-select-option :value="undefined">All Sections</a-select-option>
                <template v-for="section in sections">
                  <a-select-option :value="section.id" :key="section.id">
                  {{section.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Student Search -->
          <div class="col-md-6 col-12 mb-2">
            <div class="text-right mb-3">
              <a-input-search
                placeholder="Search Students.."
                size="large"
                v-model="search"
                @search="searchStudents"
                @change="searchStudents"
              />
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <!-- <students-table :data="data" :loading="loading" :session="selectedSession" @updateTable="handleUpdateTable" /> -->
            <student-photo-upload :data="data" :loading="loading" @updateTable="handleUpdateTable" :session="selectedSession"/>
          </div>
        </div>
        <div class="text-left">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import StudentPhotoUpload from '@/components/student/PhotoUpload/index'

import { debounce, find } from 'lodash'

export default {
  components: {
    StudentPhotoUpload,
  },
  beforeMount: function () {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('studentphotos', 22)
    rc.then(data => {
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
        this.getClasses()
        this.getStudents()
      })
      .catch(error => {
        console.log(error)
      })
  },
  created() {
    this.searchStudents = debounce(this.searchStudents, 500)
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      loading: true,
      visible: false,
      data: [],
      meta: {},
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      current: 1,
      pageSize: 10,
      selectedClass: undefined,
      selectedSection: undefined,
      selectedSession: undefined,
      sectionSpinning: false,
      classSpinning: false,
      search: null,
      permissionCheckSpinning: true,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    getStudents: function(isSearch) {
      this.loading = true

      let page = this.current
      if (isSearch) {
        page = 1
        this.current = 1
      }

      this.$http.get('/api/student', {
        params: {
          limit: this.pageSize,
          page: page,
          search: this.search,
          class_id: this.selectedClass,
          section_id: this.selectedSection,
          session_id: this.selectedSession,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    searchStudents: function(e) {
      this.search = e.target.value
      this.getStudents(true)
    },
    handleCreated: function() {
      this.getStudents()
    },
    handleUpdateTable: function() {
      this.getStudents()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getStudents()
    },
    onChange(current) {
      this.current = current
      this.getStudents()
    },

    getClasses: function() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      this.selectedSection = undefined
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
      }
      this.getStudents()
    },
    getClassSections(value) {
      this.$http.get(`/api/section/class/${value}`, {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSectionChange (value) {
      if (value) {
        this.selectedSection = value
        this.getStudents()
      } else {
        this.selectedSection = undefined
        this.getStudents()
      }
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.selectedSection = undefined
      this.selectedClass = undefined

      this.getClasses()
      this.getStudents()
    },
  },
}
</script>
